<template>
  <v-footer class="tempus-footer px-4 py-3">
    <span class="text-caption text-muted">
      &copy; {{ new Date().getFullYear() }} Tempus
    </span>
    <v-spacer />
    <v-btn
      icon
      variant="text"
      size="x-small"
      href="https://github.com/Zach-Johnson/tempus"
      target="_blank"
      class="text-muted"
    >
      <v-icon size="18">mdi-github</v-icon>
    </v-btn>
  </v-footer>
</template>

<style scoped>
.tempus-footer {
  background: transparent !important;
  border-top: 1px solid #332e28;
}
</style>
